module.exports = __webpack_public_path__ + "static/media/a2p.53f81af4.jpeg";